import { render, staticRenderFns } from "./Pharmaceutics.vue?vue&type=template&id=4dc4c3f1&scoped=true&"
import script from "./Pharmaceutics.vue?vue&type=script&lang=js&"
export * from "./Pharmaceutics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4c3f1",
  null
  
)

export default component.exports